module.exports = __webpack_public_path__ + "img/graphic_scale_with_dot.fbab019d.png";